import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let EAppointmentSource;
(function (EAppointmentSource) {
  EAppointmentSource["Sync"] = "sync";
  EAppointmentSource["Upload"] = "upload";
  EAppointmentSource["Manual"] = "manual";
  EAppointmentSource["Telehealth"] = "telehealth";
})(EAppointmentSource || (EAppointmentSource = {}));
export let EAppointmentStatusSource;
(function (EAppointmentStatusSource) {
  EAppointmentStatusSource["Integrator"] = "integrator";
  EAppointmentStatusSource["Reminder"] = "reminder";
  EAppointmentStatusSource["Ui"] = "ui";
  EAppointmentStatusSource["Waitlist"] = "waitlist";
  EAppointmentStatusSource["Reschedule"] = "reschedule";
  EAppointmentStatusSource["Telehealth"] = "telehealth";
  EAppointmentStatusSource["Assistant"] = "assistant";
})(EAppointmentStatusSource || (EAppointmentStatusSource = {}));
export let EAppointmentStatus;
(function (EAppointmentStatus) {
  EAppointmentStatus["Unconfirmed"] = "unconfirmed";
  EAppointmentStatus["Confirmed"] = "confirmed";
  EAppointmentStatus["Cancelled"] = "cancelled";
})(EAppointmentStatus || (EAppointmentStatus = {}));
export let EAppointmentStatusReason;
(function (EAppointmentStatusReason) {
  EAppointmentStatusReason["Noshow"] = "noshow";
  EAppointmentStatusReason["Arrived"] = "arrived";
  EAppointmentStatusReason["ByOffer"] = "by-offer";
})(EAppointmentStatusReason || (EAppointmentStatusReason = {}));
export let EAppointmentIntegratorUpdateStatus;
(function (EAppointmentIntegratorUpdateStatus) {
  EAppointmentIntegratorUpdateStatus["Success"] = "success";
  EAppointmentIntegratorUpdateStatus["Failure"] = "failure";
  EAppointmentIntegratorUpdateStatus["Pending"] = "pending";
})(EAppointmentIntegratorUpdateStatus || (EAppointmentIntegratorUpdateStatus = {}));
export let EAppointmentPaymentStatus;
(function (EAppointmentPaymentStatus) {
  EAppointmentPaymentStatus["Paid"] = "paid";
  EAppointmentPaymentStatus["PartiallyPaid"] = "partially-paid";
})(EAppointmentPaymentStatus || (EAppointmentPaymentStatus = {}));
export let EAppointmentFinancialInfoSyncStatus;
(function (EAppointmentFinancialInfoSyncStatus) {
  EAppointmentFinancialInfoSyncStatus["Pending"] = "pending";
  EAppointmentFinancialInfoSyncStatus["InProgress"] = "in-progress";
  EAppointmentFinancialInfoSyncStatus["Success"] = "success";
  EAppointmentFinancialInfoSyncStatus["Failure"] = "failure";
})(EAppointmentFinancialInfoSyncStatus || (EAppointmentFinancialInfoSyncStatus = {}));
export let EAppointmentInsuranceChangeType;
(function (EAppointmentInsuranceChangeType) {
  EAppointmentInsuranceChangeType["Added"] = "added";
  EAppointmentInsuranceChangeType["Deleted"] = "deleted";
  EAppointmentInsuranceChangeType["ImageUpdated"] = "image-updated";
  EAppointmentInsuranceChangeType["Updated"] = "updated";
  EAppointmentInsuranceChangeType["EligibilityFailed"] = "eligibility-failed";
  EAppointmentInsuranceChangeType["EligibilityInactive"] = "eligibility-inactive";
  EAppointmentInsuranceChangeType["CopayUnknown"] = "copay-unknown";
})(EAppointmentInsuranceChangeType || (EAppointmentInsuranceChangeType = {}));
export let EAppointmentInsuranceChangeAcknowledgementStatus;
(function (EAppointmentInsuranceChangeAcknowledgementStatus) {
  EAppointmentInsuranceChangeAcknowledgementStatus["Acknowledged"] = "acknowledged";
})(EAppointmentInsuranceChangeAcknowledgementStatus || (EAppointmentInsuranceChangeAcknowledgementStatus = {}));
export const fieldsAppointment = _extends({}, fieldsIBaseModel, {
  alertOverrideInfo: {
    type: 'Object'
  },
  appointmentChecklist: {
    type: 'Object'
  },
  arrivedAt: {
    type: 'Date'
  },
  cancelledAt: {
    type: 'Date'
  },
  cancelledBy: {
    type: 'ID',
    ref: EModel.User
  },
  checklist: {
    type: 'Object',
    array: true
  },
  confirmedAt: {
    type: 'Date'
  },
  confirmedBy: {
    type: 'ID',
    ref: EModel.User
  },
  copay: {
    type: 'Number'
  },
  createdFromReferral: {
    type: 'ID',
    ref: EModel.Referral
  },
  customerRawSource: {
    type: 'Unknown'
  },
  date: {
    type: 'Date'
  },
  duration: {
    type: 'Number'
  },
  endDate: {
    type: 'Date'
  },
  externalId: {
    type: 'Object'
  },
  externalRawSource: {
    type: 'Unknown'
  },
  facility: {
    type: 'ID',
    ref: EModel.Facility
  },
  financial: {
    type: 'Object'
  },
  insuranceInfo: {
    type: 'Object'
  },
  integratorUpdateResults: {
    type: 'Object'
  },
  notes: {
    type: 'Text'
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  paymentStatus: {
    type: 'Option',
    values: EAppointmentPaymentStatus
  },
  provider: {
    type: 'ID',
    ref: EModel.Provider
  },
  requestCancelAt: {
    type: 'Date'
  },
  requestCancelBy: {
    type: 'ID',
    ref: EModel.User
  },
  requestConfirmAt: {
    type: 'Date'
  },
  requestConfirmBy: {
    type: 'ID',
    ref: EModel.User
  },
  requestStatusSource: {
    type: 'Option',
    values: EAppointmentStatusSource
  },
  searchIds: {
    type: 'Text',
    array: true
  },
  secondaryExternalId: {
    type: 'Object'
  },
  source: {
    type: 'Option',
    values: EAppointmentSource
  },
  staffNotes: {
    type: 'Object'
  },
  stats: {
    type: 'Object'
  },
  status: {
    type: 'Option',
    values: EAppointmentStatus
  },
  statusReason: {
    type: 'Option',
    values: EAppointmentStatusReason
  },
  statusSource: {
    type: 'Option',
    values: EAppointmentStatusSource
  },
  telehealth: {
    type: 'ID',
    ref: EModel.Telehealth
  },
  type: {
    type: 'ID',
    ref: EModel.AppointmentType
  }
});